import React from 'react';
import { Divider, TextArea } from 'semantic-ui-react';
var defaultProps = {
  specialInstructions: '',
  showDivider: true,
  checkoutDisabled: false
};
var SpecialInstructions = function SpecialInstructions(_ref) {
  var specialInstructions = _ref.specialInstructions,
    onSpecialInstructionsChange = _ref.onSpecialInstructionsChange,
    _ref$showDivider = _ref.showDivider,
    showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider,
    checkoutDisabled = _ref.checkoutDisabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "item-cart-special-instructions"
  }, showDivider && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("h5", null, "SPECIAL INSTRUCTIONS"), /*#__PURE__*/React.createElement(TextArea, {
    value: specialInstructions,
    onChange: onSpecialInstructionsChange,
    disabled: checkoutDisabled
  }));
};
SpecialInstructions.defaultProps = defaultProps;
export default SpecialInstructions;